export const SAVE = 'stepClaimSummary.SAVE';
export const VALUE_CHANGED = 'stepClaimSummary.VALUE_CHANGED';
export const LOAD = 'stepClaimSummary.VALUE_LOAD';
export const RESET = 'stepClaimSummary.RESET';
export const RESET_GIVE_PERMISSION_STATE = 'stepClaimSummary.RESET_GIVE_PERMISSION_STATE';
export const SET_DEFAULT_VALUE = 'stepClaimSummary.SET_DEFAULT_VALUE';


// WEBPACK FOOTER //
// ./app/containers/FastCover/StepClaimSummary/constants.js